import { SparklesIcon } from '@heroicons/react/24/outline';
import classnames from 'classnames';
import { tAiBadgeProps } from './AiBadge.types';

/**
 * The "this one was written by the AI" chip, shared by every surface that lists
 * template names (INT-1396).
 *
 * The label is a prop rather than a `t()` call inside: the templates table and
 * the campaign picker read it from the `whatsappApi` namespace, while the chat
 * message bar has only `chat/chat` loaded — pulling a 1300-line namespace into
 * the composer for two letters is not worth it. Each caller passes the string
 * its own namespace already has.
 */
export default function AiBadge(props: tAiBadgeProps) {
  return (
    <span
      className={classnames(
        'AiBadge inline-flex flex-shrink-0 items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary',
        props.className,
      )}
    >
      <SparklesIcon className="h-3 w-3" />
      {props.label}
    </span>
  );
}
